import {Injectable} from "@angular/core";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import {Grant} from "../interfaces/grant";
import {TeacherService} from "./teacher.service";
import {Teacher} from "../interfaces/teacher";

@Injectable({
  providedIn: "root"
})
export class GrantService{
  private db = firebase.firestore();
  constructor(private teacherService: TeacherService) {}
  teacher: Teacher | null = null;

  /** Fetch all Grants */
  async getGrants(): Promise<Grant[]> {
    this.teacher = await this.teacherService.getTeacher();
    const snapshot = await this.db.collection('grant').get();
    const grants: Grant[] = [];

    snapshot.forEach(doc => {
      const data = { id: doc.id, ...doc.data() } as Grant;

      if (this.teacher?.role?.toLowerCase() === 'admin' || !data.isDeleted) {
        grants.push(data);
      }
    });
    return grants;
  }
}
